import { Button, Container, Grid, Typography } from "@mui/material";
import bc from "../Components/Assets/bc.png";
import { Box } from "@mui/system";
import React from "react";

const Hero = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#0A1316",
          padding: "30px 0px",
          display: "flex",
          // borderRadius:"0px 20px"
        }}
      >
        <Container>
          <Grid container>
            <Grid item md={6} xs={12}>
              <Box>
                <Typography
                  sx={{
                    fontSize: "36px",
                    fontWeight: "700",
                    lineHeight: "54px",
                    letterSpacing: "0em",
                    textAlign: { xs: "center", md: "left" },
                    color: "#fff",
                  }}
                >
                  About Us
                </Typography>
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: "400",
                    lineHeight: "32px",
                    letterSpacing: "0em",
                    textAlign: { xs: "center", md: "left" },
                    color: "rgba(128, 171, 158, 1)",
                    width: { xs: "100%", md: "80%" },
                  }}
                >
                  A Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  <br />
                  <br /> printing and typesetting industry. Lorem Ipsum has been
                  the industry's standard dummy text ever since the 1500s, when
                  an unknown
                </Typography>
                <Button
                  size="large"
                  sx={{
                    border: "3px solid rgba(9, 37, 30, 1)",
                    color: "#fff",
                    width: { xs: "70%", md: "35%" },
                    margin: { xs: "50px 50px", md: "50px 0px" },
                    boxShadow: { xs: "green  0px 5px 15px", md: "none" },
                  }}
                >
                  Learn More
                </Button>
              </Box>
            </Grid>
            <Grid item md={6} xs={12}>
              <Box>
                <img src={bc} alt="img" style={{ width: "100%" }} />
              </Box>
  
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Hero;
